import { useEffect, useState } from 'react';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 640);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <Sonner
      theme="light"
      className="toaster group"
      position={isMobile ? 'top-center' : 'top-right'}
      toastOptions={{
        duration: 4000,
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-white group-[.toaster]:text-night-700 group-[.toaster]:border group-[.toaster]:border-lilac-900 group-[.toaster]:shadow-md group-[.toaster]:rounded-xl group-[.toaster]:min-w-[300px]',
          description: 'group-[.toaster]:!text-night-500',
          actionButton:
            'group-[.toaster]:!bg-blueviolet group-[.toaster]:!text-white group-[.toaster]:!rounded-full group-[.toaster]:!px-4 group-[.toaster]:!py-2 group-[.toaster]:!text-sm group-[.toaster]:!font-medium hover:group-[.toaster]:!bg-blueviolet-light group-[.toaster]:!transition-colors',
          cancelButton:
            'group-[.toaster]:bg-gray-100 group-[.toaster]:text-gray-700 group-[.toaster]:rounded-full group-[.toaster]:px-4 group-[.toaster]:py-2 group-[.toaster]:text-sm group-[.toaster]:font-medium hover:group-[.toaster]:bg-gray-200 group-[.toaster]:transition-colors',
          closeButton:
            'group-[.toaster]:bg-white group-[.toaster]:text-gray-500 group-[.toaster]:border-0 hover:group-[.toaster]:bg-gray-100 group-[.toaster]:transition-colors',
          success:
            'group-[.toaster]:!text-success-dark [&_[data-title]]:!text-success-dark [&_[data-description]]:!text-success-dark [&_[data-icon]]:!text-success-dark',
          error:
            'group-[.toaster]:!bg-error-light group-[.toaster]:!border-error group-[.toaster]:!text-error-dark [&_[data-title]]:!text-error-dark [&_[data-description]]:!text-error-dark [&_[data-icon]]:!text-error-dark',
          warning: 
            'group-[.toaster]:!bg-warning-light group-[.toaster]:!border-warning group-[.toaster]:!text-warning-dark [&_[data-title]]:!text-warning-dark [&_[data-description]]:!text-warning-dark [&_[data-icon]]:!text-warning-dark',
          info: 
            'group-[.toaster]:!text-info-dark [&_[data-title]]:!text-info-dark [&_[data-description]]:!text-info-dark [&_[data-icon]]:!text-info-dark',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
